"use client";

import { Spinner } from "@stone-payments/jade";

type Props = {
  backdrop?: boolean;
} & React.HTMLAttributes<HTMLDivElement>;

export const Loader = ({ backdrop = false, ...rest }: Props) => {
  const background = backdrop
    ? "bg-[var(--comp-backdrop-background)]"
    : "bg-transparent";

  return (
    <div
      className={`fixed top-0 right-0 bottom-0 left-0 flex h-screen flex-col items-center justify-center ${background} z-1100`}
      {...rest}
    >
      <Spinner size="large" />
    </div>
  );
};
